import { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Button, CardMedia, Container, createTheme, CssBaseline, Divider, FormControlLabel, Grid, Switch, TextField, ThemeProvider, Typography } from '@mui/material'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Telefono } from '../../modules/ui/Telefono';
import { SelectCustom } from '../../modules/ui/SelectCustom';
import { SelectCustomWithOther } from '../../modules/ui/SelectCustomWithOther';
import { SelectCountryAndRegion } from '../../modules/ui/SelectCountryAndRegion';
import { useForm } from 'react-hook-form';
import { isEmail, isEmptyValue } from '../../../utils/validations';
import { generateRef } from "../../../helpers/generateRef";
import Swal from 'sweetalert2';
import moment from 'moment';
import { FileUploadCustom } from '../../modules/ui/FileUploadCustom';
import { CustomDialog } from '../../modules/dialogs/CustomDialog';
import { ParticipantWorkCustom } from '../../modules/ui/ParticipantWorkCustom';
import { postIn } from '../../../services/crudCustom';
import { renderToString } from 'react-dom/server';
import { setEmailBodyGeneral } from '../../../helpers/setEmailBodyGeneral';
import { sendEmail } from '../../../services/sendEmail';
import { createButton } from '../../../helpers/html/createButton';
// import { setBodyFirstMail } from './emails/bodies';

const inputVariant = 'standard';

//* Identificador del evento: si éste no tiene proyecto interno, el id se forma con los 5 primeros caracteres del nombre del evento como numero
const proyectId = 20010;
const eventLogo = "https://eventos.cibnor.mx/registro/en-linea/_logos/posgradoCib.png";

//* Si estas en prod
let isInProduction = (process.env.REACT_APP_TOBCC_FACTURACION !== '') 
? true : false;



export const Tutores = () => {

    //* State para los controles custom que no pueden validarse por useForm
    const [formValues, setFormValues] = useState({
        tipoRegistro: 'Tutor externo',
        // - Lo que va aditionalInfo
        cvuFileURL: '',
        // - EOF: Lo que va aditionalInfo

        registroReferencia: generateRef ({ prefix: proyectId }),
    });
    let { 
        cvuFileURL,

        registroReferencia,
    } = formValues;

    const [uploadingFile, setUploadingFile] = useState(false);
    const [sendingForm, setSendingForm] = useState(false);

    const { register, handleSubmit, setValue, formState: { errors } } = useForm();


    //* Cada que se elige un archivo para 'tipoRegistroDocURL'
    const handleDocumentUploaded = ({ exito, mensaje, data }) => {

        if (exito === 0) {
            console.log('Error', mensaje);
            Swal.fire({
                title: '¡Error!',
                text: 'Por favor intenta mas tarde.',
                icon: 'error',
                footer: `Tip: ${ mensaje || 'Check console.'}`
            })
            return;
        }

        setFormValues({ 
            ...formValues, 
            cvuFileURL: `https://eventos.cibnor.mx/registro/apiServiciosSIARF${ data }`, 
        });
    }
    

    //* Si esto se ejecuta significa que los datos en useForm ya estan validados
    // Al enviar formulario a traves de useForm
    const onSubmit = async (useFormData) => {
        //* Validaciones condicionales
        
        if (!cvuFileURL || isEmptyValue(cvuFileURL)) {
            Swal.fire({ title: 'Archivo requerido', icon: 'error', 
                text: '"Por favor adjunte su CVU" esta vacío.',
                footer: 'Anexa un documento' 
            })
            return;
        }

        //* Los campos que no estan en useForm y campos de control
        const infoAdicional = {
            cvu: useFormData.cvu || '',
            inv: useFormData.inv || '',
            snii: useFormData.snii || '',
            estudiantesAjenosAlCib: useFormData.estudiantesAjenosAlCib || '',
            cvuFileURL,
        }
        console.log('--- infoAdicional');
        Object.keys(infoAdicional).forEach(k => console.log(`${ k }:`, infoAdicional[k]));

        //* Estructura que requiere el API para guardar el registro del participante
        const recordToStore = {
            partApellidoPaterno: useFormData.partApellidoPaterno || '',
            partApellidoMaterno: useFormData.partApellidoMaterno || '',
            partNombres: useFormData.partNombres || '',
            partCorreo: useFormData.partCorreo || '',
            partPais: '',
            partEstado: '',
            tipoRegistro: '',
            tipoRegistroDocURL: '',
            registroClaveProyecto: proyectId,
            registroFecha: moment( Date.now() ).format('YYYY-MM-DDTHH:mm:ss'),
            registroReferencia,
            infoAdicional: JSON.stringify(infoAdicional), //'{ contenido adicional en formato stringified }'
            eventoId: ''
        }
        console.log('recordToStore', recordToStore);
        
        setSendingForm(true);

        //* Guardar en la base de datos el registro
        const { exito, mensaje, data } = await postIn({ table: 'RegistroGeneral', values: recordToStore });
        console.log({ exito, mensaje, data });
        
        //* Informar el resultado en caso de error
        if (exito === 0) {
            setSendingForm(false);
            Swal.fire({
                title: '¡Error!',
                text: 'Por favor intenta mas tarde / Please, try again later.',
                icon: 'error',
                footer: `Tip: ${ mensaje || 'Check console.'}`
            })
            return;
        }

        const valuesToPrint = {
            apellidoPaterno: recordToStore.partApellidoPaterno.trim() || '',
            apellidoMaterno: recordToStore.partApellidoMaterno.trim() || '',
            nombres: recordToStore.partNombres.trim() || '',
            cvu: infoAdicional.cvu,
            inv: infoAdicional.inv,
            snii: infoAdicional.snii,
            estudiantesAjenos: infoAdicional.estudiantesAjenosAlCib,
            archivoCVU: infoAdicional.cvuFileURL,
        }
        // const valuesToPrint = {
        //     // [`Apellido Paterno`]: recordToStore.partApellidoPaterno,
        //     // [`Apellido Materno`]: recordToStore.partApellidoMaterno,
        //     [`Nombre`]: `${recordToStore.partNombres.trim() } ${recordToStore.partApellidoPaterno.trim() } ${recordToStore.partApellidoMaterno.trim() }` ,
        //     [`CVU`]: infoAdicional.cvu,
        //     [`Investigador, IxM posdoc`]: infoAdicional.inv,
        //     [`SNII`]: infoAdicional.snii,
        //     [`TOTAL DE ESTUDIANTES ACTIVOS EN  POSGRADOS QUE NO SEAN DEL CIBNOR`]: infoAdicional.estudiantesAjenosAlCib,
        //     [`Archivo CVU`]: infoAdicional.cvuFileURL,
        // }
        const msgbody = renderToString( 
            setBodyEmail(valuesToPrint)
        );



        //* Enviar a Posgrado
        const emailObj = {
            "fromLabel": 'Tutores Externos',
            // "toemail": 'jcollins@cibnor.mx',
            "toemail": isInProduction ? 'posgrado-direccion@cibnor.mx' : 'jcollins@cibnor.mx',
            "subject": `Tutor registrado`,
            "message": msgbody,
            "replyto": '',
            "tocc": '',
            "tobcc": 'eventos.cibnor@cibnor.mx',
        };

        const emailResult = await sendEmail(emailObj);
        console.log(emailResult);
        
        setSendingForm(false);

        Swal.fire({
            title: 'Datos enviados',
            text: '¡Gracias por colaborar!',
            footer: 'Ya puede cerrar esta ventana.',
            icon: 'success',
            allowEscapeKey: false,
            allowOutsideClick: false,
            showConfirmButton: false,
        })

    }

    

    return (
        <ThemeProvider theme={createTheme()}>
            <Container component='main' maxWidth='sm'>
            <CssBaseline />

            <CustomDialog title='Cargando archivo / Uploading file' show={ uploadingFile } />
            <CustomDialog title='Por favor espere / Please wait' show={ sendingForm } />

            <Box sx={{ mt: 2, mb: 8, display: 'flex', flexDirection: "column", alignItems: "center" }} gap={ 2 } >
                <Box display='flex' flexDirection='row' my={ 3 }>
                    <CardMedia
                        alt={ 'tile.label2' }
                        component="img"
                        className='fadeIn'
                        image={ eventLogo }
                        sx={{ position: 'relative', width: '250px', height: 'auto' }}
                        style={{ objectFit: 'contain'}}
                    />
                </Box>
                <Typography fontSize={ 22 }>Solicitud de Información a Tutores Externos</Typography>

                {/* Inicio del formulario */}
                <form onSubmit={ handleSubmit(onSubmit) }>
                    <Box p={ 2 } boxShadow={ 3 }>
                        {/* 
                        //* Datos Personales
                        */}
                        <Grid container spacing={ 2 }>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="partApellidoPaterno"
                                    label="Apellido paterno"
                                    name="partApellidoPaterno"
                                    size="small"
                                    onChange={ ({ target }) => setValue('partApellidoPaterno', target.value) }
                                    variant={ inputVariant }
                                    { 
                                        ...register('partApellidoPaterno', {
                                            required: 'Este campo es requerido',
                                        }) 
                                    }
                                    error={ !!errors.partApellidoPaterno }
                                    helperText={ errors.partApellidoPaterno?.message }
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="partApellidoMaterno"
                                    label="Apellido materno"
                                    name="partApellidoMaterno"
                                    size="small"
                                    onChange={ ({ target }) => setValue('partApellidoMaterno', target.value) }
                                    variant={ inputVariant }
                                    { ...register('partApellidoMaterno') }
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="partNombres"
                                    label="Nombres"
                                    name="partNombres"
                                    size="small"
                                    onChange={ ({ target }) => setValue('partNombres', target.value) }
                                    variant={ inputVariant }
                                    { 
                                        ...register('partNombres', {
                                            required: 'Este campo es requerido',
                                        }) 
                                    }
                                    error={ !!errors.partNombres }
                                    helperText={ errors.partNombres?.message }
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="partCorreo"
                                    label="Correo electrónico"
                                    name="partCorreo"
                                    size="small"
                                    onChange={ ({ target }) => setValue('partCorreo', target.value) }
                                    variant={ inputVariant }
                                    { 
                                        ...register('partCorreo', {
                                            required: 'Este campo es requerido',
                                            validate: isEmail
                                        }) 
                                    }
                                    error={ !!errors.partCorreo }
                                    helperText={ errors.partCorreo?.message }
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="cvu"
                                    label="CVU"
                                    name="cvu"
                                    size="small"
                                    onChange={ ({ target }) => setValue('cvu', target.value) }
                                    variant={ inputVariant }
                                    { 
                                        ...register('cvu', {
                                            required: 'Este campo es requerido',
                                        }) 
                                    }
                                    error={ !!errors.cvu }
                                    helperText={ errors.cvu?.message }
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="inv"
                                    label="Investigador, IxM posdoc"
                                    name="inv"
                                    size="small"
                                    onChange={ ({ target }) => setValue('inv', target.value) }
                                    variant={ inputVariant }
                                    { 
                                        ...register('inv', {
                                            required: 'Este campo es requerido',
                                        }) 
                                    }
                                    error={ !!errors.inv }
                                    helperText={ errors.inv?.message }
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="snii"
                                    label="SNII"
                                    name="snii"
                                    size="small"
                                    onChange={ ({ target }) => setValue('snii', target.value) }
                                    variant={ inputVariant }
                                    { 
                                        ...register('snii', {
                                            required: 'Este campo es requerido',
                                        }) 
                                    }
                                    error={ !!errors.snii }
                                    helperText={ errors.snii?.message }
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="inv"
                                    label="Total de estudiantes ACTIVOS en Posgrados que NO sean del CIBNOR"
                                    name="estudiantesAjenosAlCib"
                                    size="small"
                                    onChange={ ({ target }) => setValue('estudiantesAjenosAlCib', target.value) }
                                    variant={ inputVariant }
                                    { 
                                        ...register('estudiantesAjenosAlCib', {
                                            required: 'Este campo es requerido',
                                        }) 
                                    }
                                    error={ !!errors.estudiantesAjenosAlCib }
                                    helperText={ errors.estudiantesAjenosAlCib?.message }
                                />
                            </Grid>
                            
                            <Grid item xs={ 12 }>
                                <Typography color='blue' fontWeight={ 600 }>Adjuntar CVU</Typography>
                                <FileUploadCustom 
                                    helperText='Anexar archivo en formato PDF / Add file in PDF format'
                                    parentCallback={ handleDocumentUploaded }
                                    parentWaitingCallback={ (val) => setUploadingFile(val) }
                                    saveFileAs= { `${ registroReferencia }_cvuTutor` }
                                    validTypes ={ ['pdf'] }
                                    variant={ inputVariant }
                                />
                            </Grid>

                            <Grid item xs={ 12 }>
                                <Button 
                                    type='submit'
                                    color='primary' 
                                    // onClick={ () => {
                                    //     // console.log(formValues);
                                    //     Object.keys(formValues).forEach(
                                    //         k => console.log(`${ k }:`, formValues[k])
                                    //     );
                                    // }}
                                    fullWidth
                                    variant='contained'
                                >
                                    Enviar
                                </Button>
                            </Grid>
                        </Grid>
                        
                    </Box>
                </form>
                                    
                {/* Footer */}
                <Grid container spacing={2} sx={{ pt: 8, pb: 2 }}>
                    <Grid item xs={12}>
                        <Divider sx={{ color: 'blue' }}/>
                        <Typography gutterBottom sx={{ fontSize:'9px', textDecorationLine: 'none' }} paragraph align="right" color="text.secondary">
                            <strong>Centro de investigaciones Biológicas del Noroeste S.C.</strong><br />
                            Instituto Politécnico Nacional 195, Playa Palo de Santa Rita Sur.<br />
                            La Paz, B.C.S., México; C.P. 23096, Tel:(52) (612) 123-8484<br />
                            <a href="https://www.cibnor.gob.mx/proteccion-datos-personales" target="_blank" rel="noreferrer" >Política de privacidad</a>
                        </Typography >
                    </Grid>
                </Grid>
            </Box>

            </Container>
        </ThemeProvider>
    )
}


const setBodyEmail = (values) => {
    console.log({values})

    const styles = {
        divMain:{ width:'96%', padding:'10px', marginRight: '4%', backgroundColor:'white' },
        divLogo:{ textAlign:'center', width:'100%' },
        divWhite:{ textAlign:'center', width:'100%', padding:'4px 0' },
        divFramed:{ border:'1px solid gray', width:'100%', padding:'4px', marginBottom: '4px' },
        divButton: { background:'#87CEEB', padding:'4px 9px', cursor:'pointer', textUnderline: 'none' },
    }

    return (
        <div style={styles.divMain}>
            <div style={styles.divLogo}>
                <img src={ eventLogo } alt="logo" width={ 300 } />
            </div>
            <div style={styles.divWhite}>
                <h2><i>Datos del tutor</i></h2>
            </div>
            <div style={styles.divFramed}>
                <p>Nombre: <strong>{`${ values.nombres.trim() } ${ values.apellidoPaterno.trim() } ${ values.apellidoMaterno.trim() }`}</strong></p>
                <p>CVU: <strong>{values.cvu }</strong></p>
                <p>Investigador, IxM posdoc: <strong>{values.inv }</strong></p>
                <p>SNII: <strong>{values.snii }</strong></p>
                <p>TOTAL DE ESTUDIANTES ACTIVOS EN  POSGRADOS QUE NO SEAN DEL CIBNOR: <strong>{values.estudiantesAjenos }</strong></p>
                <p><a href={ values.archivoCVU }>Consultar archivo</a></p>
                
                {/* <pre>{ JSON.stringify(values, null, 2) }</pre> */}
            </div>
        </div>
    )
}